import { useEffect, useState } from 'react'
import { Image } from 'expo-image'
import { getAvatarFromCache, setAvatarInCache } from '../../utils/ttlCache'
import { avatarPlaceholder } from '../customUtils/Constants'

export const UserAvatarWeb = ({ avatarUrl, style }) => {
    const __UserAvatarCache = new Map()
    const [avatar, setAvatar] = useState(avatarPlaceholder)
    useEffect(() => {
        let mounted = true
        const key = avatarUrl
        const hit = key ? __UserAvatarCache.get(key) : null
        if (hit) {
            setAvatar(hit)
            return
        }
        if (key) {
            // 1) TTL cache persistente
            getAvatarFromCache(key)
                .then((cached) => {
                    if (!mounted) return
                    if (cached) {
                        setAvatar(cached)
                        return true
                    }
                    return false
                })
                .then((servedFromCache) => {
                    if (servedFromCache) return
                    // 2) Resolver si no hubo hit
                    getImageStogeUrl(key).then(async (url) => {
                        if (!mounted) return
                        if (url) {
                            setAvatar(url)
                            try {
                                await setAvatarInCache(key, url)
                            } catch {}
                        }
                    })
                })
        }
        return () => {
            mounted = false
        }
    }, [])
    return <Image style={style} source={avatar} />
}
